import styled from 'styled-components';

import { BLACK_ALPHA_008, Z_INDEX_MAX } from 'styles/tokens';

export const OverlayContainer = styled.div`
  background: ${BLACK_ALPHA_008};
  inset: 0;
  position: fixed;
  z-index: ${Z_INDEX_MAX};
`;
